import Icon from "./IconBase";

const CheckIcon = (props) => (
  <Icon width="9" height="7" viewBox="0 0 9 7" {...props}>
    <path
      d="M2.926 6.502 1.144 4.631a.687.687 0 1 1 .996-.948l1.246 1.309L6.826.797a.688.688 0 0 1 1.063.872L3.955 6.464a.683.683 0 0 1-.505.251h-.026a.689.689 0 0 1-.498-.213z"
      fillRule="evenodd"
    />
  </Icon>
);

export default CheckIcon;
